var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-loading-page"},[_c('div',{staticClass:"c-loading-page__overlay"}),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }